import React from "react";
import "./header.css";

const Header = (props) => {
  const checkOption = (value) => {
    var checkResult = true;

    props.calcTypes.map((el) => {
      if (el.key === value) {
        checkResult = false;
      }
    });

    return checkResult;
  };

  return (
    <>
      <div className="headerBox">
        <div className="hCol1">
          <img src="./assets/logo.png" className="hLogo" alt="Frankmierz"></img>
        </div>
        <div className="hCol2">
          <h1>GENERATOR ANALIZ UMÓW KREDYTOWYCH W WALUCIE OBCEJ</h1>
        </div>
        <div className="hCol3">
          <h5 className="analysisTypeTitle">RODZAJ ANALIZY</h5>
          <select
            className="typeSelect"
            value={props.analysisType}
            onChange={props.changeAnalysisType}
          >
            <option value="chf" disabled={checkOption("chf")}>
              CHF
            </option>
            <option value="eur" disabled={checkOption("eur")}>
              EUR
            </option>
            <option value="dol" disabled={checkOption("dol")}>
              USD
            </option>
            <option value="wib" disabled={checkOption("wib")}>
              WIBOR
            </option>
            <option value="skd" disabled={checkOption("skd")}>
              SKD
            </option>
          </select>
        </div>
      </div>
    </>
  );
};

export default Header;
